import React, { useState, useContext, useEffect } from 'react';
import {
  IonContent,
  IonPage,
  IonFab,
  IonFabButton,
  IonFabList, IonItem, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonButton, IonItemOptions
} from "@ionic/react";
import {
  Table, Menu,
  IconButton,
  toaster,
  SideSheet,
  Pane,
  Heading,
  Paragraph,
  Textarea,
  PhoneIcon,
  TextInputField,
  Button,
  Icon,
  TrashIcon,
  AddIcon,
  NewPersonIcon,
  RefreshIcon,
  ResetIcon,
  ChatIcon,
  PlusIcon,
  Spinner,
  Dialog,
  EyeOpenIcon,
  TextareaField,
  Label,
  Checkbox, EditIcon
} from 'evergreen-ui'
import Row from 'react-bootstrap/Row';
import moment from 'moment';
import Col from 'react-bootstrap/Col';
import { globalContext } from "../global/Store";
import { CreateCaseQuery, CreateCaseQueryResponse } from "../global/Types";
import { dataRepoContext } from "../data-repo/DataRepo";

const CaseQueries = (props: any) => {

  const { globalDataRepo } = useContext(dataRepoContext);

  const { globalState, dispatch, globalFunctions } = useContext(globalContext);
  const [items, setItems] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [formTitle, setFormTitle] = useState('Add');
  const [newQueryResponse, setNewQueryResponse] = useState({ message: '' });
  const [selectedCaseQuery, setSelectedCaseQuery] = useState({ isClosed: 0, id: 0, responses: [] });
  const [selectedCaseQueryResponses, setSelectedCaseQueryResponses] = useState([]);
  const [querySubject, setQuerySubject] = useState("");
  const [queryText, setQueryText] = useState("");
  const [querySubjectInvalid, setquerySubjectInvalid] = useState(false);
  const [queryTextInvalid, setqueryTextInvalid] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [selectedCase, setSelectedCase] = useState({ caseStatus: { description: '' } });

  const [showNewReponseForm, setShowNewReponseForm] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [newQueryDisabled, setNewQueryDisabled] = useState(false);
  const [showNewQueryFormLoading, setShowNewQueryFormLoading] = useState(false);
  const [showFormLoading, setShowFormLoading] = useState(false);

  const [id, setId] = useState(0);
  const [caseId, setCaseId] = useState(0);
  const [fromUserId, setFromUserId] = useState(0);
  const [respondedTo, setRespondedTo] = useState(0);
  const [isDeleted, setIsDeleted] = useState(false);

  useEffect(() => {
    globalDataRepo.GetCaseQueryList(props.case.id, false).then(
      function (response: any) {
        setItems(response);

        console.log("USER");
        console.log(globalState.user);
      },
      function (error: any) {
        console.error(error);



        globalFunctions.HandleToast({
          header: "Error",
          id: "Case-Read-Error",
          description: "Could not load case query  details",
          type: "danger",
          error: error
        });
      }
    );
  }, []);


  const handleCancel = () => {
    setShowAddForm(false);
    setquerySubjectInvalid(false);
    setqueryTextInvalid(false);
    //setShowNewReponseForm(false);
  }

  const isFormValid = () => {

    var _querySubjectInvalid = (querySubject === '' ? true : false);
    var _queryTextInvalid = (queryText === '' ? true : false);

    setquerySubjectInvalid(_querySubjectInvalid);
    setqueryTextInvalid(_queryTextInvalid);

    if (_querySubjectInvalid || _queryTextInvalid) {
      return false;
    }

    return true;
  }

  const handleAdd = () => {

    if (isFormValid()) {

      setShowFormLoading(true);

      let dateTime = new Date();
      var momentDate = moment(dateTime);

      let newQuery: CreateCaseQuery = {
        QueryDate: momentDate.format(),
        QueryUpdatedDate: momentDate.format(),
        QuerySubject: querySubject,
        QueryText: queryText,
        CaseId: props.case.id,
        FromUserId: !!globalState.user.userId ? globalState.user.userId : 0,
        RespondedTo: 0,
        IsDeleted: 0,
        IsClosed: 0,
        ClosedDate: "0001-01-01T00:00:00.000Z"
      };

      //props.onCaseQueryAdd(newQuery);

      globalDataRepo.CreateCaseQuery(newQuery).then(
        function (response: any) {

          globalDataRepo.GetCaseQueryList(props.case.id, false).then(
            function (response: any) {
              setItems(response);
              setShowFormLoading(false);
              handleCancel();
            },
            function (error: any) {
              console.error(error);
              setShowFormLoading(false);
              handleCancel();
              globalFunctions.HandleToast({
                header: "Error",
                id: "Case-Read-Error",
                description: "Could not read case details from database",
                type: "danger",
                error: error
              });
            }
          );
        },
        function (error: any) {
          console.error(error);
          setShowFormLoading(false);
          handleCancel();
          globalFunctions.HandleToast({
            header: "Error",
            id: "Case-Query-Add-Error",
            description: "Could not add new case query database",
            type: "danger",
            error: error
          });
        }
      );
    }
  }

  const handleRefresh = () => {

    globalDataRepo.GetCaseQueryList(props.case.id, false).then(
      function (response: any) {

        setItems(response);
        globalFunctions.HandleToast({
          header: "Refreshed",
          id: "Case-Read-Success",
          description: "Case query list refreshed",
          type: "success",
          error: ''
        });
      },
      function (error: any) {
        console.error(error);
        globalFunctions.HandleToast({
          header: "Error",
          id: "Case-Read-Error",
          description: "Could not read case details from database",
          type: "danger",
          error: error
        });
      }
    );

  }

  const updateStatus = () => {

    if (isClosed) {

      setShowFormLoading(true);

      globalDataRepo.CloseCaseQuery(selectedCaseQuery.id).then(
        function (response: any) {
          //setCaseDetails(response);


          globalDataRepo.GetCaseQueryList(props.case.id, false).then(
            function (response: any) {
              setItems(response);
              setShowFormLoading(false);
              handleCancel();
            },
            function (error: any) {
              console.error(error);
              setShowFormLoading(false);
              handleCancel();
              globalFunctions.HandleToast({
                header: "Error",
                id: "Case-Read-Error",
                description: "Could not read case details from database",
                type: "danger",
                error: error
              });
            }
          );
        },
        function (error: any) {
          console.error(error);
          setShowFormLoading(false);
          handleCancel();
          globalFunctions.HandleToast({
            header: "Error",
            id: "Case-Query-Close-Error",
            description: "Could not close case query in database",
            type: "danger",
            error: error
          });
        }
      );
    } else {

      handleCancel();
    }


    //  props.onCaseQueryClose(selectedCaseQuery.id); }


  }

  const viewReply = (_selected: any) => {
    setNewQueryResponse(_selected,);
    setShowNewReponseForm(true);
    setFormTitle('Edit');
    setNewQueryDisabled(true);

  }

  const handleAddResponse = () => {


    setShowFormLoading(true);


    let dateTime = new Date();
    var momentDate = moment(dateTime);



    let queryResponseToAdd: CreateCaseQueryResponse = {
      ResponseDate: momentDate.format(),
      Message: newQueryResponse.message,
      CaseQueryId: selectedCaseQuery.id,
      ResponseUserId: !!globalState.user.userId ? globalState.user.userId : 0,
      CaseId: props.case.id
    }

    globalDataRepo.CreateCaseQueryResponse(queryResponseToAdd).then(
      function (response: any) {

        setShowNewReponseForm(false);

        globalDataRepo.GetCaseQueryResponseList(selectedCaseQuery.id, false).then(
          function (response: any) {

            // var _ammendedCaseQuery = selectedCaseQuery;
            // _ammendedCaseQuery.responses = response;
            setSelectedCaseQuery({ ...selectedCaseQuery, ...selectedCaseQuery.responses = response });
            setSelectedCaseQueryResponses(response);
            setShowFormLoading(false);

          },
          function (error: any) {
            console.error(error);
            setShowFormLoading(false);
            globalFunctions.HandleToast({
              header: "Error",
              id: "Case-Query-Response-List-Error",
              description: "Could not read query response list from database",
              type: "danger",
              error: error
            });
          }
        );
      },
      function (error: any) {
        console.error(error);
        setShowFormLoading(false);
        globalFunctions.HandleToast({
          header: "Error",
          id: "Case-Query-Add-Error",
          description: "Could not add new case query database",
          type: "danger",
          error: error
        });
      }
    );


    //props.onCaseQueryResponseAdd(queryResponseToAdd);
  }

  const handleCloseView = () => {
    setNewQueryResponse({ message: '' });
    setShowNewReponseForm(false);
    setFormTitle('');
    setNewQueryDisabled(false);
  }

  const handleEdit = (_selected: any) => {


    setShowFormLoading(true);
    setFormTitle('Edit');
    setShowAddForm(true);
    setId(_selected.id);
    setQuerySubject(_selected.querySubject);
    setQueryText(_selected.queryText);
    setCaseId(_selected.caseId);
    setFromUserId(_selected.fromUserId);
    setRespondedTo(_selected.respondedTo);
    setIsDeleted(_selected.isDeleted);
    setSelectedCaseQuery(_selected);
    //setSelectedCaseQueryResponses(_selected.responses);
    setIsClosed(_selected.isClosed === 0 ? false : true);
    setCurrentStatus(_selected.isClosed);
    setFormTitle(_selected.isClosed === 0 ? 'Edit' : 'View');
    setShowNewReponseForm(false);

    globalDataRepo.GetCaseQueryResponseList(_selected.id, false).then(
      function (response: any) {

        setSelectedCaseQueryResponses(response);
        setShowFormLoading(false);
        setShowAddForm(true);

      },
      function (error: any) {
        console.error(error);
        setShowFormLoading(false);
        globalFunctions.HandleToast({
          header: "Error",
          id: "Case-Query-Response-List-Error",
          description: "Could not read query response list from database",
          type: "danger",
          error: error
        });
      }
    );




  }

  const handleAddQuery = () => {
    setFormTitle('Add');
    setNewQueryResponse({ message: '' });
    setSelectedCaseQuery({ isClosed: 0, id: 0, responses: [] });
    setSelectedCaseQueryResponses([]);
    setQuerySubject("");
    setQueryText("");
    setShowAddForm(true)
    setShowNewReponseForm(false);
  }

  const deleteConfirmed = () => { }

  return (
    <Pane>
      {items !== undefined && items.length > 0 ?
        <Row style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px', marginBottom: '20px', boxShadow: 'box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)', border: '1px solid lightgray', paddingLeft: '0px', paddingRight: '0px' }}>

          <Table style={{ width: '100%' }}>
            <Table.Body>
              {items.map((query: any, index: number) => (
                <Table.Row key={index} style={{ height: 'auto' }}>
                  {query.isClosed ? <Table.Cell width={48} flex="none" style={{ background: '#52BD95', fontSize: '10px', borderCollapse: 'collapse', border: '5px', padding: '9px', color: 'white' }} > Closed </Table.Cell> : null}
                  <Table.TextCell>
                    <div style={{ padding: '10px' }}>
                      <Row>
                        <Col md={12} lg={11}>
                          <p style={{ fontSize: "15px", fontWeight: 'bold' }}>{moment(query.queryDate).format("DD/MM/YYYY")} - Query From: {query.queryUser.name}</p>
                          <p>Subject: {query.querySubject}</p>
                          <p>Message: {query.queryText}</p>
                        </Col>
                      </Row>
                    </div>
                  </Table.TextCell>
                  <Table.Cell width={48} flex="none" style={{ background: 'white', borderLeft: '1px solid lightgray' }} onClick={() => handleEdit(query)}>
                    <IconButton icon={EditIcon} height={24} appearance="minimal" />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Row>
        :
        <Row style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px', marginBottom: '20px', boxShadow: 'box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)', padding: '20px', border: '1px solid lightgray', borderRadius: '10px', paddingLeft: '0px', paddingRight: '0px' }}>
          <Heading style={{ paddingLeft: '20px' }}>No Case Queries</Heading>
        </Row>}

      {showAddForm ?
        <SideSheet
          isShown={showAddForm}
          onCloseComplete={() => handleCancel()}
          containerProps={{
            display: 'flex',
            flex: '1',
            flexDirection: 'column'
          }}
        >
          <Pane zIndex={1} tabIndex={1} flexShrink={0} elevation={0} backgroundColor="white">
            <Pane padding={16} paddingTop={32}>
              <Pane display="flex" marginBottom={10}>
                <Icon icon={ChatIcon} size={25} marginRight={10} color='#234361' />
                <Heading size={600}>{formTitle} Case Query</Heading>
              </Pane>
              <Paragraph size={400}>
                All mandatory fields must be complete before you can add a new Case Query.
              </Paragraph>
            </Pane>
          </Pane>
          <Pane flex="1" overflowY="scroll" background="tint1" padding={16}>
            <TextInputField
              label="Query Subject"
              required
              value={querySubject}
              onChange={(e: any) => setQuerySubject(e.target.value)}
              isInvalid={querySubjectInvalid}
              validationMessage={querySubjectInvalid ? "This field is required" : null}
              disabled={formTitle === 'Edit' || props.case.caseStatusId === 65 ? true : false}
            />
            <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500' }}>
              Query from user {globalState.user.forename + " " + globalState.user.surname}:</Heading>
            <TextareaField id="textarea"
              label="Query Text"
              placeholder="Case query to be added here..."
              height={150}
              value={queryText}
              onChange={(e: any) => setQueryText(e.target.value)}
              isInvalid={queryTextInvalid}
              validationMessage={queryTextInvalid ? "This field is required" : null}
              disabled={formTitle === 'Edit' ? true : false}
              required
            />
            <Pane>
              {formTitle !== "Add" ?
                <Pane style={{ display: 'inline-flex', width: '100%' }}>
                  <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500', width: '83%' }}>Responses</Heading>
                  {selectedCaseQuery.isClosed === 0 ?
                    <Heading onClick={() => { setShowNewReponseForm(true); setNewQueryDisabled(false) }} size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500', textDecoration: 'underline', cursor: 'pointer' }}>Add Response</Heading>
                    : null}
                </Pane> : null}
              {showNewReponseForm ?
                <Pane>
                  <Textarea
                    id="textarea"
                    placeholder="Reponse information to be added here..."
                    height={150}
                    //value={newQueryResponse.message}
                    onChange={(e: any) => {
                      var _response = newQueryResponse;
                      _response.message = e.target.value;
                      setNewQueryResponse(_response);
                    }}
                    marginBottom={24}
                  //disabled={newQueryDisabled ? true : false || selectedCase.caseStatus.description == "Closed" ? true : false}
                  />
                  {!newQueryDisabled ?
                    <Pane display="flex" float="right" paddingBottom={40}>
                      <Button marginRight={16} appearance="primary" intent="danger" iconBefore={TrashIcon} width={85} onClick={() => { setShowNewReponseForm(false); setNewQueryResponse({ message: '' }); }}>Cancel</Button>
                      {selectedCase.caseStatus.description !== "Closed" ? <Button appearance="primary" intent="success" iconBefore={AddIcon} width={85} paddingLeft={22} onClick={() => handleAddResponse()}>Save</Button> : null}
                    </Pane> :
                    <Pane display="flex" float="right" paddingBottom={40} marginTop={20}>
                      <Button appearance="primary" intent="danger" iconBefore={TrashIcon} width={85} onClick={() => handleCloseView()}>Close</Button>
                    </Pane>}
                </Pane> : null}
              {!showNewReponseForm && selectedCaseQuery !== null &&
                selectedCaseQueryResponses !== undefined && selectedCaseQueryResponses.length > 0 ?
                <Row style={{ marginTop: '20px', marginLeft: '0px', marginRight: '0px', width: '100%', boxShadow: 'box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)', border: '1px solid lightgray', borderRadius: '10px', paddingLeft: '0px', paddingRight: '0px' }}>
                  <Table style={{ width: '100%' }}>
                    <Table.Body>
                      {selectedCaseQueryResponses.map((_response: any, index: any) => (
                        <Table.Row key={index} style={{ height: '100%' }}>
                          <Table.TextCell style={{ padding: '0px' }}>
                            <div style={{ marginTop: '10px', paddingLeft: '10px' }}>
                              <p style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '12px', color: '#425A70', fontWeight: '400' }}>Added By: {_response.responseUser !== undefined ? _response.responseUser.name : ""}</p>
                              <p style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '12px', color: '#425A70', fontWeight: '400' }}>Added Date: {moment(_response.responseDate).format("DD/MM/YYYY")}</p>
                              <p style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '12px', color: '#425A70', fontWeight: '400' }}>Message: {_response.message}</p>
                            </div>
                          </Table.TextCell>
                          {/* <Table.Cell width={48} flex="none">
                            <IconButton onClick={() => viewReply(_response)} icon={EyeOpenIcon} height={24} appearance="minimal" />
                          </Table.Cell> */}
                        </Table.Row>
                      ))}
                    </Table.Body>
                    {showNewQueryFormLoading ?
                      <Pane display="flex" alignItems="center" justifyContent="center" height="100%" background="rgba(0,0,0,0.05)" style={{ position: 'absolute', width: '100%', top: '0' }}>
                        <Spinner></Spinner>
                      </Pane> : null}
                  </Table>
                </Row> : null}
            </Pane>
            {formTitle === 'Add' ?
              <Pane display="flex" float="right" paddingBottom={40} marginTop={20}>

                <Button marginRight={16} appearance="primary" intent="danger" iconBefore={TrashIcon} width={85} onClick={handleCancel}>Cancel</Button>
                {props.case.caseStatusId !== 65 ? <Button appearance="primary" intent="success" iconBefore={AddIcon} width={85} paddingLeft={22}
                  onClick={() => handleAdd()}>Save</Button> : null}
              </Pane> : null}

            {/* {formTitle !== 'Add' && !showNewReponseForm && currentStatus === isClosed ?
              <Pane display="flex" float="right" paddingBottom={40} marginTop={20}>
                <Button appearance="primary" intent="danger" iconBefore={TrashIcon} width={85} onClick={handleCancel}>Close</Button>
              </Pane> : null} */}

            {formTitle !== 'Add' && !showNewReponseForm && currentStatus !== isClosed && selectedCaseQuery.isClosed === 0 ?
              <Pane display="flex" float="right" paddingBottom={40} marginTop={20}>
                {props.case.caseStatusId !== 65 ? <Button appearance="primary" intent="success" iconBefore={AddIcon} width={85} paddingLeft={22} onClick={() => updateStatus()}>Save</Button> : null}
              </Pane> : null}

            {formTitle !== "Add" && !showNewReponseForm && selectedCase.caseStatus.description !== "Closed" && selectedCaseQuery.isClosed === 0 ?
              <Row style={{ marginTop: '25px' }}>
                <Col xs={12} sm={6} md={6} lg={6} style={{ display: 'inline-flex', paddingLeft: '0px', paddingRight: '0px' }}>
                  <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500' }}>Close Query?</Heading>
                  <Checkbox marginLeft={15} marginTop={2} label="Yes"
                    checked={isClosed}
                    onChange={(e) => { setIsClosed(e.target.checked ? true : false) }}
                    disabled={selectedCase.caseStatus.description == "Closed" ? true : false}
                  />

                </Col>
              </Row>
              : null}
          </Pane>

          {showFormLoading ?
            <Pane display="flex" alignItems="center" justifyContent="center" height="100%" background="rgba(0,0,0,0.05)" style={{ position: 'absolute', width: '100%', top: '0' }}>
              <Spinner></Spinner>
            </Pane> : null}
        </SideSheet>
        : null}

      {/* <Dialog
        isShown={isDeleteModalShown}
        title="Delete Case Query?"
        intent="danger"
        onCloseComplete={() => { setIsDeleteModalShown(false); }}
        confirmLabel="Delete Case Query"
        onConfirm={() => { deleteConfirmed(); }}
      >
        Are you sure you want to delete this case query? This can not be undone!
      </Dialog> */}
      <IonFab vertical="bottom" horizontal="end" edge slot="fixed" style={{ bottom: "10px", right: "15px" }}>
        <IonFabButton style={{ width: "50px", height: "50px" }}>
          <Icon icon={PlusIcon} size={20} color='white' />
        </IonFabButton>
        <IonFabList side="top" style={{ right: "-2px", marginBottom: "60px" }}>
          <IonFabButton title="Refresh" onClick={() => handleRefresh()} style={{ width: "50px", height: "50px" }}>
            <Icon icon={RefreshIcon} size={20} color='#234361' />
          </IonFabButton>
          <IonFabButton title="New Query" onClick={() => handleAddQuery()} style={{ width: "50px", height: "50px" }} >
            <Icon icon={ChatIcon} size={20} color='#234361' />
          </IonFabButton>
        </IonFabList>
      </IonFab>
    </Pane>
  );
}

export default CaseQueries 